import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { isPushEnabled, isOptedOut, isPending, isNotificationsBlocked } from 'store/entities/localSettings/selectors'
import { onGetSubscriptionState, onSubscribePush } from 'store/entities/localSettings/actions'
import PushSubscribeButton from './PushSubscribeButton'

const mapStateToProps = createStructuredSelector({
  isPushEnabled,
  isOptedOut,
  isPending,
  isNotificationsBlocked,
})

const mapDispatchToProps = {
  onGetSubscriptionState,
  onSubscribePush,
}

export default connect(mapStateToProps, mapDispatchToProps)(PushSubscribeButton)
